module.exports = __webpack_public_path__ + "assets/1792649897182/img/android-floating-icon.9a5becf4.png";